import { topics } from './topics';
import {
  reactQuestions,
  reactNativeQuestions,
  javascriptQuestions,
  typescriptQuestions,
  cssQuestions,
  oopQuestions,
  liveCodingQuestions,
  scrumQuestions,
} from './questions';

const questionsMap = {
  'react': reactQuestions,
  'react-native': reactNativeQuestions,
  'javascript': javascriptQuestions,
  'typescript': typescriptQuestions,
  'css': cssQuestions,
  'oop': oopQuestions,
  'live-coding': liveCodingQuestions,
  'scrum': scrumQuestions,
};

export const topicsWithQuestions = Object.fromEntries(
  Object.entries(topics).map(([key, meta]) => [
    key,
    {
      ...meta,
      questions: questionsMap[key] || [],
    },
  ])
);

export function getTopicConfig(key) {
  return topicsWithQuestions[key] || null;
}
